<template>
  <section id="kelas-iklim">
    <Header :scrolled="true"/>
    <div class="pageInfo bumiKini">
      <div class="pageInfoWrapper">
        <div class="worCnt">
          <h2>Week Of Resistance</h2>
          <h4 v-if="1>2">...</h4>
          <p>Tujuh hari menjelang lima tahun Paris Agreement disegel. 194 negara telah
            berkomitmen untuk menahan laju peningkatan temperatur global di bawah
            2 derajat celcius. Pemimpin-pemimpin negara berjanji membuat Bumi jadi
            tempat yang lebih layak ditinggali. Termasuk Indonesia.</p>
          <h4>Adakah perubahan yang hari ini kita rasakan?</h4>
          <p>Para pemimpin terus membuat janji tapi perubahan tidak kunjung dilakukan.</p>
          <p>Dalam 7 hari menjelang peringatan 5 tahun Paris Agreement, Greenpeace
            mengajak kamu semua untuk turut menuntut pemerintah agar lebih serius
            menangani krisis iklim dan membuat komitmen iklim yg lebih ambisius.</p>
          <p>Bergabunglah dalam barisan Week of Resistance, menjadi pasukan penyelamat
            Bumi dan pukul mundur <a href="#" class="copy-hashtag"
            title="Copy to clipboard"
            v-on:click.prevent="copy('#KrisisIklim')"
            >#KrisisIklim</a>.</p>
          <h4>Caranya?</h4>
          <p>Ikuti 7 hari tantangan Week of Resistance ini!</p>
          <ol>
            <li>
              <h5>Konten Bersama</h5>
              <p>Kami punya video yang bercerita soal
                <a href="#" class="copy-hashtag" title="Copy to clipboard"
                  v-on:click.prevent="copy('#KrisisIklim')"
                  >#KrisisIklim</a>.
                Tampaknya video
                ini masih cukup membosankan, kami butuh kamu untuk melengkapinya!<br />
                Bagaimana caranya?</p>
              <a href="#" class="btn" v-on:click.prevent="openDowloadOption = true">
                Silakan download video di sini
              </a>
              <ol>
                <li>Kamu boleh memasukkan musik, puisi, orasi, menambah video lagi,
                  gambar lagi, memberi efek, menuliskan berita, apapun*!</li>
                <li>Upload di feed akun instagram kalian dan tag kami dan gunakan hastag
                  <a href="#" class="copy-hashtag" title="Copy to clipboard"
                    v-on:click.prevent="copy('#WeekOfResistance')"
                    >#WeekOfResistance</a> <a href="#" title="Copy to clipboard"
                   class="copy-hashtag" v-on:click.prevent="copy('#BumiButuhAksi')"
                   >#BumiButuhAksi</a>.
                  Jangan private akunnya yah.</li>
                <li>Voilla! Konten Bersama-mu dengan Greenpeace siap untuk pukul mundur
                  <a href="#" title="Copy to clipboard"
                  class="copy-hashtag" v-on:click.prevent="copy('#KrisisIklim')"
                  >#KrisisIklim</a>!</li>
                <li>Cek
                  <a href="https://bumibutuhaksi.id" class="ext-link" target="_blank"
                  >bumibutuhaksi.id</a> untuk
                  saksikan hasil Konten Bersama yang lain
                  dan ikuti rangkaian lain Week Of Resistance.</li>
                <li>*perhatikan copyright jika akan menambahkan musik, video, gambar.</li>
              </ol>
            </li>
            <li>
              <h5>Tiktok Berantai</h5>
              <p>Buatlah konten join tiktok dari konten tiktok yang ada di account
                tiktok <a href="https://www.tiktok.com/@bumibutuhaksi"
                class="ext-link" target="_blank">@bumibutuhaksi</a>! Upload
                dan jangan lupa tag
                <a href="https://www.tiktok.com/@greenpeaceid"
                target="_blank" class="ext-link">@greenpeaceid</a> <a
                href="https://www.tiktok.com/@bumibutuhaksi"
                target="_blank" class="ext-link">@bumibutuhaksi</a> serta gunakan hastag
                <a href="" title="Copy to clipboard" class="copy-hashtag"
                v-on:click.prevent="copy('#BumiButuhAksi')">#BumiButuhAksi</a>.</p>
            </li>
            <li><h5>Ikuti Kuis Iklim & Isi Climate Action Bingo di instagram story
              <a href="http://instagram.com/greenpeaceid" target="_blank"
              class="ext-link">@greenpeaceid</a> setiap
              hari!</h5>
              <a href="https://drive.google.com/drive/folders/1-2SWpBtmQ10uiOKl-oQli3t4QxMEPpT8"
                class="btn" target="_blank">Template Climate Action Bingo bisa
                kamu download disini</a>
            </li>
            <li><h5>Video Kompilasi</h5>
              <p><a href="" title="Copy to clipboard" class="copy-hashtag"
                v-on:click.prevent="copy('#KrisisIklim')">#KrisisIklim</a> bukan
                mitos! Krisis Iklim mengancam kita semua, aku, kamu,
                mereka dan anak cucu kita di masa depan. Berikut pesan contoh untuk
                video ini.</p>
              <div class="theVideo">
                <VuePlyr ref="video">
                  <video></video>
                </VuePlyr>
              </div>
              <!--
              <iframe src="https://www.youtube.com/embed/KwHCho8DYRk"
                frameborder="0" allow="accelerometer; autoplay; clipboard-write;
                encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              -->
              <p></p>
              <p>Kamu punya pesan tentang krisis iklim yang ingin kamu sampaikan kepada
                siapapun? Ayo, kirimkan pesanmu melalui sebuah video seperti diatas
                dengan ketentuan sebagai berikut:</p>
              <ol class="a">
                <li>Ungkapkan pesanmu (saran, puisi, statement, lagu atau apapun) di
                  dalam sebuah video dengan format landscape berdurasi 20-30 detik.</li>
                <li>Kamu bisa menggunakan atribut, banner atau apapun didalam video tersebut.</li>
                <li>Ucapkan <b>“BUMI BUTUH AKSIMU UNTUK MEMUKUL MUNDUR KRISIS IKLIM!”</b> di
                akhir video.</li>
                <li>Upload video kamu disini <a href="https://bit.ly/videokompilasiwor" class="ext-link"
                  target="_blank">bit.ly/videokompilasiwor</a></li>
              </ol>
              <p>Video yang kamu kirimkan akan dikompilasi menjadi satu video yang akan
                diupload di Youtube Greenpeace Indonesia serta Website Bumibutuhaksi.
                Gabung sekarang! Bumi Butuh Aksi dan suaramu sekarang juga!</p>
            </li>
            <li><h5>Twibbon Bumi Butuh Aksi.</h5>
              <p>Yuk gunakan Twibbon Bumi Butuh Aksi sebagai tanda bahwa dirimu mengikuti
                tantangan di Week Of Resistance.</p>
              <p>Gunakan link ini untuk menambahkan fotomu di twibbon: <a
                href="https://twibbonize.com/BumiButuhAksi" class="ext-link" target="_blank"
                >https://twibbonize.com/BumiButuhAksi</a>.</p>
            </li>
          </ol>
          <p>Ada hadiah menarik dari Greenpeace Indonesia untuk tiga karya terbaik
            pada kategori konten bersama, tiktok berantai, dan video kompilasi!</p>
        </div>
      </div>
    </div>
    <div class="downloadOptionOverlay" v-if="openDowloadOption"
      v-on:click="openDowloadOption = false"></div>
    <div class="downloadOption" v-if="openDowloadOption">
      <div class="close" v-on:click="openDowloadOption = false"></div>
      <!-- <h4>Download Video</h4> -->
      <p class="subtitle">Pilih ukuran video</p>
      <li v-on:click="dowloadVideo('potrait')" class="potrait">
        <span>Download</span>
        <h4>Ukuran Potrait</h4>
        <p>Cocok untuk instagram story, video tiktok, dan lainya.</p>
      </li>
      <li v-on:click="dowloadVideo('square')" class="square">
        <span>Download</span>
        <h4>Ukuran Square</h4>
        <p>Cocok untuk post instagram.</p>
      </li>
    </div>
    <div class="snackbar" v-if="snackbar">{{snackbar}}</div>
  </section>
</template>

<script>
import VuePlyr from 'vue-plyr';
import Header from '@/components/Header.vue';

export default {
  name: 'home',
  components: { Header, VuePlyr },
  data() {
    return {
      snackbar: null,
      openDowloadOption: false,
    };
  },
  methods: {
    dowloadVideo(type) {
      this.openDowloadOption = false;
      if (type === 'potrait') {
        window.open('https://drive.google.com/file/d/14RTJREyXRO3EnRGVGLElK-ohzal-3iNi/view');
      } else {
        window.open('https://drive.google.com/file/d/136h62N1gIBz61hA93YrZAUhVM59xg3Xx/view');
      }
    },
    copy(text) {
      this.copyTextToClipboard(text);
    },
    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;

      // Avoid scrolling to bottom
      textArea.style.top = '0';
      textArea.style.left = '0';
      textArea.style.position = 'fixed';

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand('copy');
        if (successful) {
          this.snackbar = `${text} copied to clipboard.`;
          setTimeout(() => {
            this.snackbar = null;
          }, 1600);
        }
      } catch (err) { err.message(); }

      document.body.removeChild(textArea);
    },
    copyTextToClipboard(text) {
      if (!navigator.clipboard) {
        this.fallbackCopyTextToClipboard(text);
        return;
      }
      navigator.clipboard.writeText(text).then(() => {
        this.snackbar = `${text} copied to clipboard.`;
        setTimeout(() => {
          this.snackbar = null;
        }, 1600);
      });
    },
  },
  computed: {
    video() {
      return this.$refs.video.player;
    },
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = 'Week Of Resistance - Bumi Butuh Aksi';
    const sources = [
      {
        src: 'https://api.bumibutuhaksi.id/media/video/720-video-1607341275611.mp4',
        type: 'video/mp4',
        size: 720,
      },
      {
        src: 'https://api.bumibutuhaksi.id/media/video/480-video-1607341275611.mp4',
        type: 'video/mp4',
        size: 480,
      },
      {
        src: 'https://api.bumibutuhaksi.id/media/video/360-video-1607341275611.mp4',
        type: 'video/mp4',
        size: 360,
      },
    ];
    this.video.source = {
      type: 'video',
      title: 'Contoh video',
      sources,
    };
  },
};
</script>

<style scoped lang="scss">
  .theVideo{
    box-shadow: 4px 4px 0 #31c1f4;
  }
  .snackbar{
    position: fixed;
    bottom: 10px;
    left: 50%;
    background-color: rgba(0,0,0,.8);
    color: #fff;
    padding: 10px 20px;
    z-index: 999;
    border-radius: 6px;
    transform: translateX(-50%);
    @media (max-width: 680px) {
      left: 30px; right: 30px;
      transform: none;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .downloadOptionOverlay{
    background-color: rgba(0,0,0,.5);
    position: fixed;
    left: 0; right: 0; top: 0; bottom: 0;
    z-index: 998;
  }
  .downloadOption{
    background-color: #fff;
    padding: 36px 50px 30px;
    position: fixed;
    top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
    box-shadow: 2px 2px 4px rgba(0,0,0,.2);
    border-radius: 5px;
    @media (max-width: 680px) {
      top: auto;
      left: 0; right: 0; bottom: 0;
      transform: none;
      border-radius: 10px 10px 0 0;
      padding: 20px 30px 5px;
      .close{
        display: none;
      }
    }
    .close{
      position: absolute;
      right: 14px; top: 10px;
      width: 40px; height: 40px;
      border-radius: 50%;
      background-image: url(../assets/close.png);
      background-size: 16px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .5;
      &:hover{
        background-color: #eee;
        opacity: .8;
        cursor: pointer;
      }
    }
    h4{
      margin: 0 0 6px;
      font-size: 20px;
    }
    .subtitle{
      margin: 0 0 16px;
      font-size: 16px;
      color: #767676;
      text-transform: uppercase;
      font-weight: bold;
    }
    li{
      list-style: none;
      border-radius: 5px;
      border: #ddd 1px solid;
      padding: 10px 20px;
      margin-bottom: 16px;
      padding-left: 64px;
      position: relative;
      cursor: pointer;
      span{
        float: right;
        text-transform: uppercase;
        color: #fff;
        font-weight: bold;
        font-size: 14px;
        margin-top: 15px;
        display: none;
      }
      &:before{
        content: "";
        display: block;
        position: absolute;
        top: 50%; left: 16px;
        border-radius: 4px;
        width: 30px; height: 30px;
        // background-image: url(../assets/down-arrow.png);
        background-size: 20px auto;
        margin-top: -17px;
        // background-color: #f5f5f5;
        border: #555 2px solid;
      }
      &:after{
        content: "";
        display: block;
        position: absolute;
        top: 50%; left: 18px;
        border-radius: 4px;
        width: 30px; height: 30px;
        background-image: url(../assets/play.png);
        background-size: 10px auto;
        background-repeat: no-repeat;
        background-position: center;
        margin-top: -15px;
      }
      &.potrait:before{
        height: 50px;
        margin-top: -27px;
      }
      h4{
        margin: 0 0 2px;
      }
      p{
        margin: 0;
        color: #767676;
        font-size: 15px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      &:hover{
        background-color: #31c1f4;
        border-color: #31c1f4;
        color: #fff;
        p{
          color: #fff;
        }
        span{
          display: inline-block;
        }
        &:before{
          border-color: #fff;
          // background-image: url(../assets/down-arrow-white.png);
        }
        &:after{
          background-image: url(../assets/play-white.png);
        }
      }
      &:active{
        background-color: #139dce;
      }
    }
  }
  .pageInfo{
    // background-image: url(../assets/kelas-iklim.jpg);
    background-size: cover;
    background-position: center;
    position: relative;
    margin-top: 71px;
    @media (max-width: 760px) {
      margin-top: 62px;
    }
    &:before{
      content: ""; display: block;
      position: absolute;
      top: 0; right: 0; left: 0; bottom: 0;
      background-image: linear-gradient(rgba(255, 255, 255, .5), #fff);
    }
    .pageInfoWrapper{
      position: relative;
      z-index: 2;
      margin: 0 auto -120px;
      padding: 40px 0 160px;
      // text-align: center;
      .worCnt{
        max-width: 800px;
        margin: 0 auto;
        > ol > li{
          margin-bottom: 40px;
        }
      }
      iframe{
        width: 100%;
        height: 440px;
        @media (max-width: 768px) {
          height: 400px;
        }
        @media (max-width: 680px) {
          height: 180px;
        }
      }
      h2{
        max-width: 800px;
        margin: 0 auto 20px;
        font-size: 60px;
      }
      h4{
        margin: 40px auto 16px;
        font-size: 24px;
        max-width: 800px;
        line-height: 1.5;
      }
      p{
        margin: 0 auto 16px;
        max-width: 800px;
        font-size: 20px;
        line-height: 1.5;
        @media (max-width: 680px) {
          font-size: 19px;
          line-height: 1.4;
        }
      }
      a{
        color: #0b9a6b;
        text-decoration: none;
        font-weight: bold;
        &:hover{
          color: #32c1f4;
        }
        &.copy-hashtag{
          display: inline-block;
          padding-right: 30px;
          position: relative;
          // background-color: #eee;
          border-radius: 50px;
          padding-left: 6px;
          &:before{
            content: "";
            display: block;
            position: absolute;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            right: 0; top: 0;
            background-image: url(../assets/copy.png);
            background-size: 18px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          &:hover{
            background-color: #f9f9f9;
            &:before{
              background-image: url(../assets/copy-hover.png);
            }
          }
          &:active{
            background-color: #eee;
          }
        }
        &.ext-link{
          display: inline-block;
          padding-right: 30px;
          position: relative;
          // background-color: #eee;
          border-radius: 50px;
          padding-left: 6px;
          &:before{
            content: "";
            display: block;
            position: absolute;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            right: 0; top: 0;
            background-image: url(../assets/external-link.png);
            background-size: 18px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          &:hover{
            background-color: #f9f9f9;
            &:before{
              background-image: url(../assets/external-link-hover.png);
            }
          }
          &:active{
            background-color: #eee;
          }
        }
      }
      a.btn{
        color: #fff;
        margin-bottom: 20px;
        &:hover{
          color: #fff;
        }
      }
      ol{
        margin: 0;
        padding: 0;
        padding-left: 24px;
        font-size: 20px;
        &.a{
          list-style: lower-alpha;
        }
        li{
          margin: 0 0 10px;
        }
        h5{
          margin: 0 0 10px;
          font-size: 20px;
          font-weight: bold;
          line-height: 1.5;
        }
      }
      @media (max-width: 760px) {
        padding-top: 30px;
        h2{
          font-size: 50px;
          margin-left: -3px;
        }
        h4{
          font-size: 22px;
        }
      }
    }
  }
</style>
